module.exports = __webpack_public_path__ + "static/media/15_l_krilo_5.47_69.72.3ba832f5.png";